import DocumentSubcategoryList from "../components/document-subcategory/DocumentSubcategoryCrud";

const DocumentSubcategoryCrudPage = () => {
  return (
    <>
      <DocumentSubcategoryList />
    </>
  );
};

export default DocumentSubcategoryCrudPage;
